var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"props-group"},[_c('el-form-item',{attrs:{"label":"高度自适应"}},[_c('el-checkbox',{model:{value:(_vm.component.properties.heightAdaptation),callback:function ($$v) {_vm.$set(_vm.component.properties, "heightAdaptation", $$v)},expression:"component.properties.heightAdaptation"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47336d6f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/componentAttr/height-adaptation.vue
// module id = null
// module chunks = 